/** Default blob-to-file download. */
export const saveBlobAsFile = (blobData: Blob, fileName: string) => {
  const file = new File([blobData], fileName);
  const url = window.URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};
